import { render, staticRenderFns } from "./navMain.vue?vue&type=template&id=99de1074"
import script from "./navMain.vue?vue&type=script&lang=js"
export * from "./navMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopBanner: require('/vercel/path0/components/topBanner.vue').default,Menu: require('/vercel/path0/components/menu.vue').default,Img: require('/vercel/path0/components/ui/img.vue').default,MenuItem: require('/vercel/path0/components/menuItem.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default,SearchAlgolia: require('/vercel/path0/components/searchAlgolia.vue').default,ContactForm: require('/vercel/path0/components/contactForm.vue').default})
